import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CookiePolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="cookie-policy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Înapoi la pagina principală
          </Button>
        </Link>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center">
              <Cookie className="w-7 h-7 text-blue-600" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900 font-['Archivo']">
                Politica de Cookies
              </h1>
              <p className="text-slate-500">Ultima actualizare: Martie 2026</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none">
            <h2>1. Ce sunt Cookie-urile?</h2>
            <p>
              Cookie-urile sunt fișiere text mici stocate pe dispozitivul dumneavoastră când 
              vizitați un website. Acestea permit site-ului să vă recunoască și să rețină 
              informații despre vizita dumneavoastră, cum ar fi preferințele sau datele de 
              autentificare.
            </p>

            <h2>2. Cum Folosim Cookie-urile</h2>
            <p>Platforma AUTO CORA utilizează cookie-uri pentru:</p>
            <ul>
              <li>Funcționarea corectă a platformei</li>
              <li>Menținerea sesiunii de autentificare</li>
              <li>Salvarea preferințelor dumneavoastră</li>
              <li>Înțelegerea modului în care utilizați platforma</li>
              <li>Îmbunătățirea experienței utilizatorului</li>
            </ul>

            <h2>3. Tipuri de Cookie-uri Utilizate</h2>

            <h3>3.1. Cookie-uri Esențiale (Obligatorii)</h3>
            <p>
              Acestea sunt necesare pentru funcționarea platformei și nu pot fi dezactivate. 
              Includ:
            </p>
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="text-left">Cookie</th>
                  <th className="text-left">Scop</th>
                  <th className="text-left">Durată</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>auth_token</code></td>
                  <td>Autentificare utilizator</td>
                  <td>Sesiune / 30 zile</td>
                </tr>
                <tr>
                  <td><code>cookie_consent</code></td>
                  <td>Stochează preferința cookies</td>
                  <td>1 an</td>
                </tr>
                <tr>
                  <td><code>session_id</code></td>
                  <td>Identificare sesiune</td>
                  <td>Sesiune</td>
                </tr>
              </tbody>
            </table>

            <h3>3.2. Cookie-uri de Performanță</h3>
            <p>
              Ne ajută să înțelegem cum interacționați cu platforma, colectând informații 
              anonime despre paginile vizitate și eventualele erori.
            </p>

            <h3>3.3. Cookie-uri Funcționale</h3>
            <p>
              Permit platformei să rețină alegerile dumneavoastră (precum tema preferată sau 
              progresul în cursuri) pentru o experiență personalizată.
            </p>

            <h3>3.4. Cookie-uri Terțe</h3>
            <p>
              Putem utiliza servicii terțe care setează propriile cookie-uri:
            </p>
            <ul>
              <li><strong>Stripe:</strong> pentru procesarea securizată a plăților</li>
              <li><strong>YouTube/Vimeo:</strong> pentru afișarea video-urilor educaționale</li>
            </ul>

            <h2>4. Cum să Gestionați Cookie-urile</h2>
            
            <h3>4.1. Prin Setările Browser-ului</h3>
            <p>
              Puteți controla și șterge cookie-urile prin setările browser-ului dumneavoastră:
            </p>
            <ul>
              <li><strong>Chrome:</strong> Setări → Confidențialitate și securitate → Cookie-uri</li>
              <li><strong>Firefox:</strong> Opțiuni → Confidențialitate & Securitate</li>
              <li><strong>Safari:</strong> Preferințe → Confidențialitate</li>
              <li><strong>Edge:</strong> Setări → Cookie-uri și permisiuni site</li>
            </ul>

            <h3>4.2. Prin Banner-ul Nostru de Cookies</h3>
            <p>
              La prima vizită, veți vedea un banner care vă permite să acceptați sau să 
              refuzați cookie-urile neesențiale. Puteți modifica această alegere oricând 
              ștergând cookie-urile din browser și reîncărcând pagina.
            </p>

            <h2>5. Consecințele Dezactivării Cookie-urilor</h2>
            <p>
              Dacă dezactivați cookie-urile esențiale, este posibil ca unele funcționalități 
              ale platformei să nu funcționeze corect, inclusiv:
            </p>
            <ul>
              <li>Autentificarea în cont</li>
              <li>Salvarea progresului în cursuri</li>
              <li>Procesarea plăților</li>
            </ul>

            <h2>6. Actualizări ale Politicii</h2>
            <p>
              Putem actualiza această politică periodic. Vă încurajăm să o consultați 
              regulat pentru a fi la curent cu modul în care folosim cookie-urile.
            </p>

            <h2>7. Contact</h2>
            <p>
              Pentru întrebări despre utilizarea cookie-urilor, ne puteți contacta prin 
              pagina de <Link to="/contact" className="text-blue-600 hover:underline">Contact</Link>.
            </p>
            <p>
              Pentru informații despre datele personale, consultați{" "}
              <Link to="/politica-confidentialitate" className="text-blue-600 hover:underline">
                Politica de Confidențialitate
              </Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
